export default __webpack_public_path__ + "static/card1-tablet-e3b9778b5abc0845e1783f286d20f9b0.png";